import { useEffect } from 'react';
import { useRouter } from 'next/router';

/**
 * Session storage key /checkout-stripe falls back to when its own URL
 * carries no `?coupon=` query parameter.
 */
const COUPON_SESSION_STORAGE_KEY = 'coupon';

/**
 * FFH-1769 coupon capture on checkout entry pages.
 *
 * Stores an incoming `?coupon=` query parameter in session storage so
 * it survives the click-through to /checkout-stripe, which reads the
 * stored value when its own URL has no coupon. Session storage (rather
 * than anything longer-lived) is intentional: the coupon should only
 * apply to the tab session the link opened.
 *
 * Mounted on /join and on the Sanity funnel renderer so coupon links
 * (including the `allow_coupon_entry` promo-box sentinel) behave the
 * same on funnels as on /join.
 */
export const useCaptureCouponFromUrl = (): void => {
  const { query } = useRouter();

  useEffect(() => {
    const { coupon } = query;
    if (coupon && typeof coupon === 'string') {
      sessionStorage.setItem(COUPON_SESSION_STORAGE_KEY, coupon);
    }
  }, [query]);
};
